"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useWalletModal = useWalletModal;
var react_1 = require("react");
var useWallet_1 = require("./useWallet");
/**
 * Hook that provides state and controls for a wallet selection modal
 *
 * This hook makes it easy to create a custom wallet selection UI
 *
 * @returns State and controls for a wallet modal
 */
function useWalletModal() {
    var _a = (0, react_1.useState)(false), visible = _a[0], setVisible = _a[1];
    var _b = (0, react_1.useState)(null), selectedWallet = _b[0], setSelectedWallet = _b[1];
    var select = (0, useWallet_1.useWallet)().select;
    var showModal = (0, react_1.useCallback)(function () {
        setVisible(true);
    }, []);
    var hideModal = (0, react_1.useCallback)(function () {
        setVisible(false);
    }, []);
    var handleSelectWallet = (0, react_1.useCallback)(function (walletName) {
        setSelectedWallet(walletName);
        if (walletName) {
            select(walletName);
        }
    }, [select]);
    return {
        visible: visible,
        showModal: showModal,
        hideModal: hideModal,
        selectedWallet: selectedWallet,
        setSelectedWallet: handleSelectWallet
    };
}
